import React from "react";
import styles from "../../asset/WhoWeAre/WhoWeAre.module.scss";
import WhoWeAreImage from "../../../src/asset/images/whoweare.png"
import { useNavigate } from "react-router-dom";



const WhoWeAre = () => {
  const navigate = useNavigate();
  return (
    <section className={styles.whoWeAre}>
      <div className={styles.content}>
        <h1>Who we are</h1>
        <h2>
          Bring your ideas to life with saidigitizing
        </h2>
        <p>
          saidigitizing  is the story of three individuals brought together by their shared vision for a company where they could leverage their combined strengths in the ITES and outsourcing space to provide professional quality graphic design and digitizing solutions to clients around the world.
        </p>
        
        {/* <a href="https://nausetscreenprinting.com/services/" target="_blank" rel="noreferrer"> */}
          <button  onClick={() => navigate("/about")} className={styles.btn}>Find Out</button>
        {/* </a> */}
      </div>

      <div className={styles.imageWrapper}>
        <img
          src={WhoWeAreImage}  // replace with your image path
          alt="Nauset Screen Printing Sign"
        />
      </div>
    </section>
  );
};

export default WhoWeAre;
